import React from "react";
import { useHistory } from "react-router-dom";
import isScript from "../../hooks/isScript";
import MailForm from "../mailForm/mailForm";
import { useTranslation } from "react-i18next";

const VoucherPage = () => {
  const history = useHistory();
  isScript();

  const { t } = useTranslation("pricing");
  const { t: isLang } = useTranslation("type");

  return (
    <>
      <main className="voucher-main voucher">
        <section className="banner-main voucher">
          <div className="inner">
            <div>
              <img
                className="voucher-logo fade-up"
                src="./assets/logo/logo_wh.png"
                alt="Ready Play Logo"
              />
              <h2 className="sub-tit fade-up voucher">
                <span>
                  메타버스 이벤트가 처음이신가요?
                  <br />
                </span>
                언제 어디서나 모두가 함께하는 ReadyPlay!
              </h2>
            </div>
            <div className="fade-up wh100 inview">
              <span className="tooltip bounce">
                <ion-icon name="mail"></ion-icon>&ensp;자세한 내용이
                궁금하시다면 언제든지 연락주세요!
              </span>
              <a href="#contact" className="btn-main">
                문의하기
              </a>
            </div>
          </div>
        </section>
        <section className="container plan support">
          <div className="inner">
            <div className="fade-up">
              <h2 className=".md clearfix">
                <span className="sub-tit">
                  2022 비대면 서비스 바우처 수요기업 선정 시
                </span>
                <span className="main-tit">
                  ReadyPlay 사용료&nbsp;&nbsp;
                  <strong>
                    <em>70</em>
                    <small>%</small> 정부지원
                  </strong>
                </span>
              </h2>
            </div>
            <div className="fade-up support-wrapper">
              <ul className="tit-div">
                <li>
                  Standard Price
                  <br />
                  <span>for K-voucher</span>
                </li>
                <li className="tag-div">
                  <span>#메타버스</span>
                  <span>#가상회의</span>
                  <br />
                  <span>#컨퍼런스</span>
                  <span>#온라인미팅</span>
                </li>
              </ul>
              <ul className="price-div">
                <li>
                  <p>1개 이벤트 당 (VAT 별도)</p>
                  <p>₩ 2,000,000</p>
                </li>
                <li>
                  <p>정부 지원금 (70%)</p>
                  <p>₩ 1,400,000</p>
                </li>
                <li className="sum">
                  <p>기업 부담금 (30%)</p>
                  <p>₩ 600,000</p>
                </li>
              </ul>
            </div>
            <div class="notice right">*부가세 100% 환급 가능</div>
          </div>
        </section>

        <section className="container plan">
          <div className="inner">
            <div className="fade-up">
              <h2 className="main-tit fade-up">Main Function </h2>
            </div>
            <div className="table-wrapper function fade-up">
              <div className="table-grid__body">
                <div className="column">
                  <div className="tit">
                    <b>항목</b>
                  </div>
                  <div className="col-2-6">가상공간</div>
                  <div>아바타</div>
                  <div className="col-7-12">기능</div>
                  <div>가상공간</div>
                  <div className="col-13-16">기능</div>
                  <div>통계</div>
                  <div>CMS</div>
                  <div>참가인원</div>
                  <div>월드(가상공간) 유지기간</div>
                </div>
                <div className="column">
                  <div className="tit">
                    <b>세부설명</b>
                  </div>
                  <div>기본 가상공간 템플릿 제공</div>
                  <div>
                    가상공간 개설 (공개 / 비공개 / 이벤트 설정 / 공지사항 등록)
                  </div>
                  <div>가상공간 검색 (제목 / 유저 취향 별)</div>
                  <div>게시판 / 방명록</div>
                  <div>3D 아바타 (기본 아바타 / 유저 셀피 제작)</div>
                  <div>음성 / 텍스트 채팅 (+이모티콘)</div>
                  <div>파일 공유 (Video / Image / PDF)</div>
                  <div>영상 스트리밍 (Video / Youtube Live)</div>
                  <div>친구 추가 (팔로우 / 팔로잉) </div>
                  <div>가상공간 내 친구 초대 / 강퇴</div>
                  <div>가상공간 내 홍보물 설치</div>
                  <div>화상채팅</div>
                  <div>이벤트 녹화 </div>
                  <div>지난 프로그램 다시보기</div>
                  <div>통계 제공 항목</div>
                  <div>관리자 페이지</div>
                  <div>1개 가상공간 당 접속 인원</div>
                  <div>행사 종료 후 유지기간</div>
                </div>
                <div className="column">
                  <div className="tit">
                    <b>Standard (바우처 제안)</b>
                  </div>
                  <div className="col-2-12">
                    <ion-icon
                      name="checkmark-outline"
                      className="icon-check"
                    ></ion-icon>
                  </div>
                  <div>최대 3개</div>
                  <div>
                    <p>
                      1명
                      <br />
                      <small className="mb">(Speaker Only)</small>
                    </p>
                  </div>
                  <div>
                    <p>
                      <ion-icon
                        name="checkmark-outline"
                        className="icon-check"
                      ></ion-icon>
                      <br />
                      <small className="mb">(편집 제외)</small>
                    </p>
                  </div>
                  <div>
                    <ion-icon
                      name="checkmark-outline"
                      className="icon-check"
                    ></ion-icon>
                  </div>
                  <div>접속 인원, ID</div>
                  <div>
                    <ion-icon
                      name="close-outline"
                      className="icon-close"
                    ></ion-icon>
                  </div>
                  <div>
                    <p>
                      100명
                      <br />
                      <small className="mb">
                        Avatar : 20 / Voice Only : 30+
                      </small>
                    </p>
                  </div>
                  <div>1개월</div>
                </div>
              </div>
            </div>
            <div className="table-wrapper optional">
              <div className="table-grid__body">
                <div className="column">
                  <div className="col-1-4">
                    + Option
                    <br />
                  </div>
                </div>
                <div className="column">
                  <div>플레이월드 신규 제작</div>
                  <div>아바타 신규 제작</div>
                  <div>아바타 파츠 신규 제작</div>
                </div>
                <div className="column">
                  <div>
                    <ion-icon
                      name="close-outline"
                      className="icon-close"
                    ></ion-icon>
                  </div>
                  <div>
                    <ion-icon
                      name="close-outline"
                      className="icon-close"
                    ></ion-icon>
                  </div>
                  <div className="col-2">
                    상・하의 각 1개
                    <br />총 2 SET
                  </div>
                </div>
              </div>
            </div>
            <p className="notice">
              ※ Option 항목은 작업 범위에 따라 추가 비용이 발생합니다.
            </p>
          </div>
        </section>

        <section className="howto container">
          <div className="inner">
            <h2 className="main-tit fade-up">
              비대면 서비스 바우처 구매방법{" "}
              <ion-icon name="card-outline"></ion-icon>
            </h2>
            <ul className="howto table-grid__body fade-up">
              <li>
                <span className="howto label">1</span>비대면 서비스 바우처
                수요기업 신청 및 선정
                <ion-icon
                  name="chevron-down-outline"
                  class="icon-down bounce"
                ></ion-icon>
              </li>
              <li>
                <span className="howto label">2</span>바우처 결제수단 발급
                (바우처 카드 또는 바우처 상품권)
                <ion-icon
                  name="chevron-down-outline"
                  class="icon-down  bounce"
                ></ion-icon>
              </li>
              <li>
                <span className="howto label">3</span>서비스 상품 신청
                <ion-icon
                  name="chevron-down-outline"
                  class="icon-down bounce"
                ></ion-icon>
              </li>
              <li>
                <span className="howto label">4</span>바우처 사용/결제
                <ion-icon
                  name="chevron-down-outline"
                  class="icon-down  bounce"
                ></ion-icon>
              </li>
              <li>
                <span className="howto label">5</span>사용 점검
              </li>
            </ul>
          </div>
        </section>

        <section className="qa container">
          <div className="inner">
            <h2 className="main-tit fade-up">비대면 서비스 바우처 Q&amp;A</h2>
            <ul className="qa__list fade-up">
              <li>
                <button className="qa__label" type="button">
                  비대면 서비스 바우처 사업이란?
                </button>
                <div className="qa__content">
                  <p>
                    {" "}
                    중소기업이 비대면 서비스 바우처 공급기업의 서비스를 사용할
                    경우, 최대 400만원(자부담금 30% 포함) 이내 바우처를 지급하는
                    정부 지원사업
                  </p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  바우처는 언제 사용할 수 있는가?
                </button>
                <div className="qa__content">
                  <p>
                    {" "}
                    중수요기업으로 선정되어 예산 확정이 완료되면 비대면 바우처
                    플랫폼에서 ReadyPlay 서비스를 구매할 수 있음
                  </p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  수요기업은 어떻게 신청하는가?
                </button>
                <div className="qa__content">
                  <p>
                    신청기간 : 2022년 4월 1일(금) 09:00 ~ 4월 14일(목),
                    16:00까지
                    <br />
                    신청방법 : K-비대면 바우처 플랫폼{" "}
                    <a href="https://www.k-voucher.kr/" target="_blank">
                      ( <ion-icon name="link-outline"></ion-icon>{" "}
                      www.k-voucher.kr )
                    </a>
                    에서 온라인 신청
                    <br />
                    <small>
                      ※ 2022년 모집규모의 2배수(3만개 내외)를 초과하는 경우
                      신청은 조기 마감
                    </small>
                  </p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  비대면 서비스 바우처 사업 상세 문의
                </button>
                <div className="qa__content">
                  <p>
                    K-비대면바우처플랫폼 콜센터 │ <em>1670-1357</em>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </section>

        <MailForm />
      </main>
    </>
  );
};

export default VoucherPage;
